module.exports = __webpack_public_path__ + "img/碳中和碳源管理平台.c40cfb2c.png";